import WithToken from 'auth/components/WithToken';
import dynamic from 'next/dynamic';
import { DynamicModuleLoader } from 'redux-dynamic-modules-react-18';
import { Modules, loadReduxModules } from 'src/common/reduxStore/modules';
import ProductDescriptionPage from 'src/modules/parkplusStoreV2/components/ProductDescription';

function ParkplusStoreProduct(props) {
  return (
    <DynamicModuleLoader modules={loadReduxModules([Modules.ParkplusStoreV2])}>
      <ProductDescriptionPage {...props} />
    </DynamicModuleLoader>
  );
}

const FinalComp: any = WithToken(ParkplusStoreProduct);

export default FinalComp;

FinalComp.getInitialProps = ({ query, pathname, asPath }) => ({
  query,
  pathname,
  asPath,
});
